var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_container"},[_c('header-section'),_c('top-section'),_c('main-section'),_c('footer-com')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }